import { MobileOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";

import { AUTH_PLACEHOLDERS } from "@/constants";
import { validatePhoneValue } from "@/utils/auth-account";

interface PhoneFormItemProps {
  autoFocus?: boolean;
  label?: string;
  name?: string;
  placeholder?: string;
}

export const PhoneFormItem = ({
  autoFocus = false,
  label = "Số điện thoại",
  name = "phone",
  placeholder = AUTH_PLACEHOLDERS.phone,
}: PhoneFormItemProps) => (
  <Form.Item
    label={label}
    name={name}
    rules={[
      {
        validator: async (_, value: string | undefined) => {
          const error = validatePhoneValue(value ?? "");

          if (error) {
            throw new Error(error);
          }
        },
      },
    ]}
  >
    <Input
      autoComplete="tel"
      autoFocus={autoFocus}
      inputMode="numeric"
      prefix={<MobileOutlined />}
      placeholder={placeholder}
    />
  </Form.Item>
);
